module.exports = (__webpack_require__(2))(2873);